import { render, staticRenderFns } from "./InvoicePdfPage.vue?vue&type=template&id=1af84199&"
import script from "./InvoicePdfPage.vue?vue&type=script&lang=js&"
export * from "./InvoicePdfPage.vue?vue&type=script&lang=js&"
import style0 from "./InvoicePdfPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports